export const apiUrlGetEssenceGroup = '/products/essence-groups/';
